import { BASE_URL_API } from "../../constants";
import fetcher from "../../utils/fetcher";

export const _api_get_solde_by_leave_id = async (leave_id) => {
    return fetcher(BASE_URL_API + "/leave/" + leave_id + "/balance", {
        method: "GET",
        credentials: "include",
    });
};
